/**
 * Simple utility to get the current user's role
 * Based on tokens stored in localStorage
 */

// Role constants matching backend
// Backend: role_type: 1 = Admin, 2 = Employee, 3 = Customer
export const ROLES = {
  ADMIN: 'admin',
  EMPLOYEE: 'employee',
  CUSTOMER: 'customer',
  GUEST: 'guest',
};

/**
 * Get the current user's role based on localStorage tokens
 * @returns {string} 'admin' | 'employee' | 'customer' | 'guest'
 */
export const getUserRole = () => {
  const adminToken = localStorage.getItem('adminToken');
  const employeeToken = localStorage.getItem('employeeToken');
  const authToken = localStorage.getItem('authToken');

  if (adminToken) return ROLES.ADMIN;
  if (employeeToken) return ROLES.EMPLOYEE;
  if (authToken) return ROLES.CUSTOMER;
  return ROLES.GUEST;
};